enum PickingTypes {
    Simple = 's',
    Advanced = 'a'
}

export default PickingTypes;
